import React from 'react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

const clients = [
  {
    title: 'Sales teams',
    description:
      "You need a better way to find and qualify leads. Your team spends too much time on research that could be automated, and the tools you've tried are either too expensive or built for someone else's sales process.",
  },
  {
    title: 'Service businesses',
    description:
      'You manage clients, projects, or fieldwork, and the combination of email, spreadsheets, and shared folders is starting to cause problems. Something gets missed. Updates take too long. A proper tool would fix it.',
  },
  {
    title: 'Internal operations',
    description:
      "There's a process in your business that works because one person holds it together. When that person is out, things slip. We build tools that make the process work on its own. Reliable, transparent, and easy for everyone to use.",
  },
];

export const WhoWeWorkWith = () => {
  const { elementRef, getRevealStyle } = useScrollReveal();

  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="container-professional" ref={elementRef} style={getRevealStyle()}>
        <div className="text-center mb-16">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-primary font-mono mb-4">
            Clients
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Who we work with
          </h2>
          <p className="text-[rgba(255,255,255,0.5)] max-w-xl mx-auto">
            Three types of clients we work with most.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {clients.map((client) => (
            <div
              key={client.title}
              className="group relative bg-[#111111] rounded-2xl border border-[rgba(255,255,255,0.08)] p-8 hover:border-primary/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_50px_-15px_hsl(190_100%_50%_/_0.15)]"
            >
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/5 via-primary/[0.02] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="relative z-10">
                <h3 className="text-xl font-bold text-white mb-4">{client.title}</h3>
                <p className="text-[rgba(255,255,255,0.65)] leading-relaxed text-sm">
                  {client.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
